import type { ReactNode } from 'react';

export function Field({
  label,
  children,
  hint,
}: {
  label: string;
  children: ReactNode;
  hint?: string;
}) {
  return (
    <label className="field">
      <span className="field__label">{label}</span>
      {children}
      {hint && <span className="small muted">{hint}</span>}
    </label>
  );
}

export function StatusBadge({ status }: { status?: string | null }) {
  if (!status) return null;
  const mod = status.toLowerCase().replace(/[^a-z]/g, '');
  const known = ['active', 'pending', 'revoked', 'failed', 'suspended', 'terminated'];
  const cls = known.includes(mod) ? `badge badge--${mod}` : 'badge';
  return <span className={cls}>{status.replace(/_/g, ' ')}</span>;
}
